import { useCallback, useRef, useState } from 'react';
import { useDownloadOmmnioSignSignedZipMutation } from 'store/app/entities/EmployeesApiSlice';
import {
  parseFilenameFromContentDisposition,
  saveBlobDownload,
} from 'utils/ommniosignSignedZipDownload';
import { I18n } from 'utils/i18n';

/**
 * Company-admin ZIP export: same mandatory-read documents as the profile list (signatures, ack PDFs, or originals).
 */
export default function useDownloadSignedZip({ employee }) {
  const [downloadZip] = useDownloadOmmnioSignSignedZipMutation();
  const lockRef = useRef(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const runDownload = useCallback(async () => {
    if (lockRef.current || !employee?._id) return;
    lockRef.current = true;
    try {
      const result = await downloadZip({ _id: employee._id }).unwrap();
      const filename =
        parseFilenameFromContentDisposition(result.contentDisposition) ||
        `mandatory-reads-${employee._id}.zip`;
      saveBlobDownload(result.blob, filename);
      setSnackbar({
        open: true,
        message: I18n.t('EmployeeDrawer.ReleasePhone.downloadSignedZipSuccess'),
        severity: 'success',
      });
    } catch (e) {
      const status = e?.status ?? e?.originalStatus;
      const serverMsg = e?.data?.data?.message || e?.data?.message;
      const msg =
        status === 404
          ? I18n.t('EmployeeDrawer.ReleasePhone.downloadSignedZipEmpty')
          : serverMsg || I18n.t('EmployeeDrawer.ReleasePhone.downloadSignedZipError');
      setSnackbar({ open: true, message: msg, severity: 'error' });
    } finally {
      lockRef.current = false;
    }
  }, [downloadZip, employee?._id]);

  return { runDownload, snackbar, setSnackbar };
}
